import React from 'react';
import propTypes from 'prop-types';
import PaginationSummaries from '../../../components/Paginations/PaginationSummaries';
import { Tbl, TblHead, TblBody } from '../../../components/Tbl';
import RowItem from './RowItem';
import { generateNumber } from '../../../utils';

const dataHeader=[
  'No.','Rack Name','Capacity','Updated','Action'
];
class List extends React.Component {
  constructor(props){
    super(props);
    this.state = {
      _data: []
    }
  }
  componentWillReceiveProps(nextProps){
    if(!nextProps.isLoading && nextProps.isLoading != this.props.isLoading){
      this.setState({
        _data: nextProps.data
      })
    }
  }
  render (){
    return (
      <div className="table-responsive" ref={this.props.innerRefs}>
        <PaginationSummaries
          from={this.props.from}
          to={this.props.to}
          total={this.props.total}
        />
        <Tbl>
          <TblHead
            renderChildren={this.props.onRenderHeader}
          />
          <TblBody
            isLoad={this.props.isLoading}
            hasRow={this.state._data.length>0}
            columnCount={7}
            renderChildren={()=> {
              if(!this.props.isLoading&&this.state._data.length>0){
                const { currentPage, perPage } = this.props;
                return (
                  this.state._data.map((item,index)=>{
                    const number = generateNumber(perPage,currentPage,index);
                    return (
                      <RowItem
                        key={item.id}
                        id={item.id}
                        rowId={number}
                        name={item.name}
                        maxCapacity={item.max_capacity}
                        currentCapacity={item.user_sells_count}
                        updatedAt={item.updated_at}
                        approvedAt={item.approved_at}
                      />
                    )
                  })
                )
              }
              return null;
            }}
          />
        </Tbl>
      </div>
    )
  }
}
export default List;

List.propTypes = {
  from: propTypes.number,
  to: propTypes.number,
  total: propTypes.number,
  currentPage: propTypes.number,
  perPage: propTypes.oneOfType([propTypes.number, propTypes.string]),
  statusCode: propTypes.any,
  defaultRoute: propTypes.string.isRequired,
  isLoading: propTypes.bool
}
List.defaultProps = {
  from: 0,
  to: 0,
  total: 0,
  currentPage: 0,
  perPage: 0
}